import React from 'react';
import {Flex, Table} from "antd";
import {useCompetenceMatrix} from "../hooks/useCompetenceMatrix";

const Step6Matrix = ({data, connectionsRef}) => {
    const {columns, dataSource} = useCompetenceMatrix(data, connectionsRef);

    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={"small"}>
            <Table
                columns={columns}
                dataSource={dataSource}
                rowKey="key"
                pagination={false}
                bordered
            />
        </Flex>
    );
};

export default Step6Matrix;
